export default {
  "common": {
    "appName": "CleanFlow",
    "confirm": "OK",
    "cancel": "キャンセル",
    "save": "保存",
    "add": "追加",
    "delete": "削除",
    "edit": "編集",
    "back": "戻る",
    "close": "閉じる",
    "loading": "読み込み中...",
    "submitting": "送信中...",
    "saving": "保存中...",
    "retry": "再試行",
    "language": "言語",
    "logout": "ログアウト",
    "optional": "任意",
    "copy": "コピー",
    "copied": "コピーしました",
    "saved": "保存しました",
    "archive": "アーカイブ",
    "restore": "戻す",
    "disable": "停止",
    "enable": "再開",
    "networkError": "ネットワークに接続できません。通信状況をご確認ください",
    "unknownError": "問題が発生しました。しばらくしてからお試しください"
  },
  "auth": {
    "loginTitle": "ログイン",
    "loginSubtitle": "民泊清掃の手配",
    "orgCode": "組織コード",
    "orgCodePlaceholder": "オーナーは必須、管理者は空欄可",
    "registerSuccessWithCode": "登録完了！組織コードを控えてください：{code}",
    "orgCodeHint": "オーナー/スタッフは必須。プラットフォーム管理者は空欄",
    "username": "ユーザー名",
    "usernamePlaceholder": "ユーザー名",
    "usernameHint": "英数字または携帯番号、3〜64文字",
    "password": "パスワード",
    "passwordPlaceholder": "パスワード",
    "loginButton": "ログイン",
    "loggingIn": "ログイン中…",
    "goRegister": "組織を登録",
    "registerTitle": "組織を登録",
    "registerSubtitle": "組織を作成して管理者になります",
    "orgName": "組織名",
    "displayName": "氏名",
    "locale": "表示言語",
    "contactPhoneOptional": "電話番号（任意）",
    "registerSubmit": "登録してはじめる",
    "backToLogin": "ログインへ戻る",
    "changePasswordTitle": "パスワード変更",
    "changePasswordForced": "新しいパスワードを設定してください",
    "currentPassword": "現在のパスワード",
    "newPassword": "新しいパスワード",
    "confirmPassword": "新しいパスワード（確認）",
    "passwordMinLength": "パスワードは8文字以上",
    "passwordMismatch": "新しいパスワードが一致しません",
    "changePasswordSuccess": "パスワードを変更しました"
  },
  "role": {
    "PLATFORM_ADMIN": "システム管理者",
    "OWNER": "オーナー",
    "STAFF": "スタッフ"
  },
  "nav": {
    "calendar": "清掃カレンダー",
    "review": "確認待ち",
    "biz": "経営",
    "tasks": "自分の作業",
    "records": "清掃記録",
    "finance": "売上と精算",
    "payroll": "自分の収入",
    "settings": "設定"
  },
  "status": {
    "archived": "アーカイブ済み",
    "disabled": "停止中"
  },
  "settings": {
    "title": "設定",
    "masterData": "基本データ",
    "clients": "家主の管理",
    "buildings": "棟の管理",
    "rooms": "部屋と料金",
    "staff": "スタッフの管理",
    "account": "アカウント",
    "changePassword": "パスワード変更",
    "orgLoginCode": "組織コード",
    "orgLoginCodeHint": "",
    "about": "このアプリについて",
    "version": "バージョン",
    "logoutTitle": "ログアウトしますか？",
    "logoutMessage": "次回はユーザー名とパスワードの入力が必要になります。登録済みのデータは失われません。",
    "operations": "運用設定"
  },
  "client": {
    "title": "家主",
    "newTitle": "家主を追加",
    "editTitle": "家主を編集",
    "empty": "家主がまだありません",
    "emptyHint": "家主を追加すると、棟と部屋を登録できます",
    "total": "全 {count} 件",
    "name": "名称",
    "namePlaceholder": "例：山田管理",
    "nameHint": "同じ名称は登録できません",
    "nameRequired": "名称を入力してください",
    "contactName": "担当者",
    "contactPhone": "電話番号",
    "postalCode": "請求書の郵便番号",
    "address": "請求書の住所",
    "addressHint": "請求書の「御中」の下に入ります。空なら名称だけ出ます",
    "note": "メモ",
    "notePlaceholder": "例：毎月25日締め",
    "summary": "{buildings}棟 {rooms}室",
    "archiveTitle": "この家主をアーカイブしますか？",
    "archiveMessage": "アーカイブすると、この家主の棟は新規の割り当て候補に出なくなります。過去の記録はそのまま残ります。",
    "restoreTitle": "この家主を戻しますか？",
    "restoreMessage": "戻すと、有効な棟に再び割り当てできるようになります。",
    "deleteTitle": "この家主を削除しますか？",
    "deleteMessage": "このデータは完全に削除され、元に戻せません。",
    "deleteBlocked": "棟があるためアーカイブのみ可能です"
  },
  "building": {
    "title": "棟",
    "newTitle": "棟を追加",
    "editTitle": "棟を編集",
    "empty": "棟がまだありません",
    "emptyHint": "棟を追加すると、その下に部屋を作れます",
    "emptyFiltered": "この家主にはまだ棟がありません",
    "total": "全 {count} 棟",
    "allClients": "すべての家主",
    "client": "家主",
    "clientLocked": "作成後に家主は変更できません",
    "clientRequired": "家主を選択してください",
    "name": "棟名",
    "namePlaceholder": "例：A棟、戸建てA",
    "nameHint": "同じ家主の中では重複不可。家主が違えば同名でも可",
    "nameRequired": "棟名を入力してください",
    "address": "住所",
    "addressPlaceholder": "スタッフが現地に向かう際に使います",
    "note": "メモ",
    "notePlaceholder": "例：キーボックスの暗証番号、ゴミ出しルール",
    "sortOrder": "並び順",
    "sortOrderHint": "数字が小さいほど前に表示されます",
    "roomCount": "{count}室",
    "noClientYet": "先に家主を登録してください",
    "noClientYetHint": "棟はいずれかの家主に属します",
    "goCreateClient": "家主を登録する",
    "archiveTitle": "この棟をアーカイブしますか？",
    "archiveMessage": "アーカイブすると新規の割り当て候補に出なくなります。過去の記録はそのまま残ります。",
    "restoreTitle": "この棟を戻しますか？",
    "restoreMessage": "戻すと再び割り当てできるようになります。",
    "deleteTitle": "この棟を削除しますか？",
    "deleteMessage": "このデータは完全に削除され、元に戻せません。",
    "deleteBlocked": "部屋があるためアーカイブのみ可能です"
  },
  "room": {
    "title": "部屋と料金",
    "newTitle": "部屋を追加",
    "editTitle": "部屋を編集",
    "empty": "この棟にはまだ部屋がありません",
    "emptyHint": "部屋を作成し、清掃料金を設定します",
    "total": "全 {count} 室",
    "allBuildings": "すべての棟",
    "building": "棟",
    "buildingLocked": "作成後に棟は変更できません",
    "buildingRequired": "棟を選択してください",
    "name": "部屋番号",
    "namePlaceholder": "例：101",
    "nameHint": "同じ棟の中では重複できません",
    "nameRequired": "部屋番号を入力してください",
    "clientPrice": "家主への請求",
    "staffBasePay": "スタッフへの支払（基本）",
    "staffBasePayHint": "スタッフごとに個別調整もできます",
    "priceRequired": "金額を入力してください",
    "grossMargin": "1件あたり粗利",
    "marginNegative": "この料金では赤字になります。問題なければ保存してください",
    "note": "メモ",
    "notePlaceholder": "例：ツイン、ソファベッドあり",
    "sortOrder": "並び順",
    "priceSummary": "請求{client}　支払{staff}",
    "noBuildingYet": "先に棟を登録してください",
    "noBuildingYetHint": "部屋はいずれかの棟に属します",
    "goCreateBuilding": "棟を登録する",
    "suspended": "停止中",
    "archiveTitle": "この部屋を停止しますか？",
    "archiveMessage": "停止すると新規の清掃登録の候補に出なくなります。過去の記録はそのまま残ります。",
    "restoreTitle": "この部屋を再開しますか？",
    "restoreMessage": "再開すると再び割り当てできるようになります。",
    "noDeleteHint": "部屋は削除できません（過去の清掃記録が参照しているため）。停止をご利用ください"
  },
  "staff": {
    "title": "スタッフ",
    "newTitle": "スタッフを追加",
    "editTitle": "スタッフを編集",
    "detailTitle": "スタッフ詳細",
    "empty": "スタッフがまだいません",
    "emptyHint": "スタッフアカウントを作成すると割当できます",
    "total": "全 {count} 名",
    "username": "ユーザー名",
    "usernamePlaceholder": "例：tanaka",
    "usernameHint": "英数字・携帯電話番号など、3〜64文字。作成後は変更できません",
    "usernameInvalid": "英数字または携帯番号で、3〜64文字入力してください",
    "usernameLocked": "ユーザー名は作成後に変更できません",
    "displayName": "氏名",
    "displayNamePlaceholder": "割り当て画面に表示される名前",
    "displayNameRequired": "氏名を入力してください",
    "passwordAutoHint": "初期パスワードは 12345 です。変更は任意です。",
    "noDeleteHint": "スタッフは削除できません（過去の清掃記録と給与明細が参照しているため）。停止をご利用ください",
    "phone": "携帯番号",
    "status": "状態",
    "active": "有効",
    "notActivated": "未設定",
    "notActivatedHint": "初期パスワードのままです",
    "lastLogin": "最終ログイン",
    "neverLoggedIn": "ログイン履歴なし",
    "adjustedCount": "個別単価{count}件",
    "roomRates": "部屋ごとの単価設定",
    "credentialTitle": "アカウントを作成しました",
    "credentialResetTitle": "パスワードを再発行しました",
    "credentialHint": "このパスワードを控えてください。閉じると再表示できません。",
    "credentialOrgCode": "組織コード",
    "credentialUsername": "ユーザー名",
    "credentialPassword": "初期パスワード",
    "credentialDone": "控えました",
    "resetPassword": "パスワード再発行",
    "resetTitle": "パスワードを再発行しますか？",
    "resetMessage": "パスワードを初期値 12345 に戻します。現在のパスワードは無効になります。",
    "disableTitle": "このスタッフを停止しますか？",
    "disableMessage": "停止すると直ちにログインできなくなります。過去の清掃記録と給与明細はすべて残ります。",
    "enableTitle": "このスタッフを再開しますか？",
    "enableMessage": "再開すると元のユーザー名とパスワードでログインできます。"
  },
  "rate": {
    "title": "{name} の部屋単価",
    "intro": "調整した部屋だけが個別に記録され、それ以外は部屋の基本単価が適用されます。複数人で行う作業ではこの個別単価は使いません。",
    "adjustedInBuilding": "{count}件調整",
    "noAdjustment": "調整なし",
    "totalAdjusted": "調整 {count} 件",
    "resetAll": "すべて既定に戻す",
    "resetAllTitle": "すべて既定の単価に戻しますか？",
    "resetAllMessage": "このスタッフの個別単価 {count} 件を削除し、以後は部屋の基本単価が適用されます。元に戻せません。",
    "editTitle": "{room} の単価",
    "payAmount": "このスタッフへの支払額",
    "payRequired": "金額を入力してください",
    "defaultIs": "部屋の既定 {amount}",
    "note": "調整の理由",
    "notePlaceholder": "例：ベテランなので上乗せ",
    "noteHint": "数か月後に見返したときに必要になります",
    "restoreDefault": "既定に戻す",
    "overriddenFrom": "既定 {default} → ",
    "emptyRooms": "部屋がまだありません",
    "emptyRoomsHint": "先に「部屋と料金」で部屋を登録してください"
  },
  "calendar": {
    "title": "清掃カレンダー",
    "today": "今日",
    "totalOfDay": "全 {count} 件",
    "empty": "この日の清掃予定はありません",
    "emptyHint": "右下のボタンから登録できます",
    "groupCount": "{count} 件",
    "unassigned": "未割当",
    "sameDayCheckin": "当日チェックイン",
    "stayGuests": "{count}名",
    "stayNights": "{count}泊",
    "sofaBed": "ソファベッド要",
    "sharedBy": "{count}人で清掃",
    "weekdays": [
      "日",
      "月",
      "火",
      "水",
      "木",
      "金",
      "土"
    ],
    "monthLabel": "{year}年{month}月",
    "monthShort": "{year}/{month}"
  },
  "task": {
    "newTitle": "清掃登録",
    "editTitle": "清掃の編集",
    "date": "日付",
    "building": "棟",
    "pickBuildingFirst": "先に棟を選んでください",
    "buildingPlaceholder": "棟を選択",
    "room": "部屋",
    "roomPlaceholder": "部屋を選択",
    "roomFixed": "登録済みの部屋（変更不可・備考のみ編集可）",
    "roomRequired": "部屋を選択してください",
    "basePayHint": "この部屋の基本給 {amount}",
    "alreadyRegistered": "本日登録済み",
    "alreadyRegisteredHint": "この部屋は本日すでに清掃予定があります。もう一件登録しますか",
    "workKind": "作業の種類",
    "workKindCleaning": "清掃",
    "workKindOther": "その他",
    "workKindHint": "清掃不要で別の作業がある場合は「その他」。給与と請求書に載ります",
    "workLabel": "内容",
    "workLabelPlaceholder": "例：フィルター交換、鍵の補充",
    "workLabelRequired": "内容を入力してください",
    "priceAdjust": "金額を調整する",
    "priceAdjustHint": "今回だけ変えるときにチェック。しない場合は部屋の既定額",
    "clientPriceThisTime": "依頼主への請求（今回）",
    "staffPayThisTime": "スタッフ給与（今回）",
    "stayTitle": "宿泊情報",
    "sameDayCheckin": "当日チェックイン",
    "sameDayCheckinHint": "本日チェックアウト、午後に新しいお客様が入るため当日中に清掃が必要",
    "guestCount": "宿泊人数",
    "nights": "宿泊日数",
    "needsSofaBed": "ソファベッドの用意",
    "stayHint": "これらはスタッフ向けの作業情報で、金額には影響しません",
    "notSet": "未入力",
    "assignTitle": "担当者",
    "tapStaffHint": "タップで担当者を選択/解除",
    "sharedCleaning": "共同清掃",
    "tapStaffHintSingle": "1人のみ選択。別の人を押すと切り替え",
    "tapStaffHintShared": "共同清掃オン：複数選択可",
    "addAssignee": "追加",
    "noStaff": "スタッフがいません",
    "noStaffHint": "先に「スタッフ管理」でアカウントを作成してください",
    "unassignedHint": "後から割り当てることもできます",
    "loadOnDate": "本日{count}件",
    "payTitle": "給与の配分",
    "payModePercent": "割合",
    "payModeAmount": "金額",
    "poolHint": "部屋の基本給 {amount}",
    "splitEvenly": "均等",
    "totalPercent": "合計 {percent}%",
    "totalAmount": "合計 {amount}",
    "overPool": "基本給より {amount} 多い",
    "underPool": "基本給より {amount} 少ない",
    "multiIgnoresOverride": "複数人での清掃は部屋の基本給を配分します。個人ごとの調整額は使いません。",
    "singlePay": "給与 {amount}",
    "note": "備考",
    "notePlaceholder": "例：チェックアウトが遅いため14時以降に訪問",
    "lockedTitle": "{name} が完了報告済み",
    "lockedHint": "報告済みの作業は部屋と金額を変更できません。差し戻してから変更してください。",
    "rejectedTitle": "差し戻し済み・再提出待ち",
    "rejectedHint": "部屋・宿泊情報・担当を直せます。写真の再提出も可。保存や再提出後は差し戻し／確認待ちのままです。",
    "cancelTask": "この作業を取消",
    "cancelTitle": "この作業を取り消しますか？",
    "cancelMessage": "記録は残りますが、カレンダーには表示されなくなります。予約キャンセルなどの場合にお使いください。",
    "deleteTask": "削除",
    "deleteTitle": "この作業を削除しますか？",
    "deleteMessage": "完全に削除され、元に戻せません。登録ミスの場合のみお使いください。予約キャンセルは「取消」をお使いください。",
    "deletePastTitle1": "過去日の予定を削除しますか？",
    "deletePastMessage1": "{date} の過去予定です。削除すると元に戻せません。続行しますか？",
    "deletePastTitle2": "再確認：過去予定を削除",
    "deletePastMessage2": "{date} · {room} の清掃登録を完全に削除します。もう一度確認してください。",
    "deletePastNext": "削除を続ける",
    "deletePastConfirm": "削除する",
    "pastNoSchedule": "本日より前の日付にも新規登録できます",
    "submitAsOwner": "オーナーが代わりに完了報告",
    "resubmitAsOwner": "完了報告を出し直す",
    "submittedAsOwner": "代行報告しました。確認待ちに入ります"
  },
  "review": {
    "rejectReasonLabel": "差し戻し理由",
    "coworker": "合掃メンバー",
    "title": "確認待ち",
    "detailTitle": "確認詳細",
    "count": "{count} 件",
    "filterAll": "すべて",
    "empty": "確認待ちの作業はありません",
    "emptyHint": "スタッフが完了報告するとここに表示されます。カレンダーから「代行報告」もできます",
    "shared": "共同",
    "sharedWith": "共同：{names}",
    "ownerReported": "代報",
    "submitted": "報告",
    "totalPay": "スタッフへの支払",
    "totalPaySum": "支払合計",
    "clientPrice": "家主への請求",
    "margin": "粗利",
    "approve": "確認",
    "reject": "差し戻し",
    "approveAll": "すべて確認",
    "approved": "確認しました",
    "approvedAll": "{count} 件を確認しました",
    "rejected": "差し戻しました",
    "rejectTitle": "この作業を差し戻す",
    "rejectHint": "差し戻し理由：",
    "rejectPlaceholder": "例：浴室の写真が不鮮明です。撮り直してください",
    "quickReasons": "よく使う",
    "reasonBlurry": "写真が不鮮明",
    "reasonMissingRoom": "部屋の写真が足りない",
    "reasonNoReceipt": "領収書がない",
    "reasonAmountWrong": "金額が合わない",
    "confirmReject": "差し戻す",
    "photos": "完了写真",
    "photosSoon": "写真アップロード接続後に表示されます",
    "payBreakdown": "各自の支払",
    "staffNote": "備考",
    "noPhotos": "写真はありません",
    "expenses": "経費",
    "paidBy": "{name} が立替",
    "clientCharge": "家主請求",
    "staffPay": "スタッフ支給",
    "expenseMargin": "経費利益: {amount}",
    "completionPhotos": "完了写真",
    "noCompletionPhotos": "完了写真なし",
    "noReceipt": "領収書なし",
    "receiptPhotos": "領収書",
    "clientCharges": "家主請求",
    "staffPays": "スタッフ支給",
    "clientTotal": "家主合計",
    "staffTotal": "スタッフ合計",
    "saveBilling": "金額を保存",
    "billingSaved": "金額を更新しました",
    "passThroughHint": "乾燥機代・消耗品は実費をスタッフ立替として計上し、家主にも請求します"
  },
  "biz": {
    "title": "経営",
    "prevMonth": "前月",
    "nextMonth": "翌月",
    "allClients": "すべての家主",
    "clientReceivable": "家主への請求",
    "staffPayable": "スタッフへの支払",
    "margin": "粗利",
    "marginRate": "粗利率 {rate}%",
    "counts": "確認済み {approved} 件 ·· 確認待ち {pending} 件",
    "expenseNote": "うち立替精算 {amount}（相殺のため売上に含めません）",
    "byClient": "家主別",
    "byStaff": "スタッフ別",
    "clientRow": "請求{receivable}  粗利{margin}",
    "staffTasks": "{count}件",
    "goReview": "確認待ちへ",
    "empty": "この月に確認済みの掃除はまだありません",
    "emptyHint": "「確認待ち」で確認すると金額がここに表示されます",
    "payout": {
      "PENDING": "未払い",
      "PAID": "支払済"
    },
    "advanceReceivable": "立替請求分 {amount}",
    "payoutPending": "未支給",
    "payoutPaid": "支給済"
  },
  "staffTasks": {
    "empty": "この日に割り当てられた作業はありません",
    "emptyHint": "割り当て後にここに表示されます",
    "sameDay": "当日チェックイン",
    "other": "その他の作業",
    "sameDayBadge": "本日チェックインあり",
    "status": {
      "PENDING": "割当待ち",
      "ASSIGNED": "作業待ち",
      "SUBMITTED": "確認待ち",
      "APPROVED": "承認済み",
      "REJECTED": "差し戻し・再送信可",
      "CANCELLED": "キャンセル済み"
    },
    "tapToReport": "完了報告する",
    "cannotEditHint": "現在の状態：{status}。「未完了」または「差戻し」のときだけ乾燥代・写真・領収書を入力できます。",
    "myPay": "明細",
    "me": "自分"
  },
  "staffIncome": {
    "title": "自分の収入",
    "empty": "今月の収入記録はまだありません",
    "emptyHint": "確認後に金額が表示されます",
    "total": "今月の合計",
    "cleaning": "清掃",
    "reimbursement": "立替",
    "special": "特別費用",
    "details": "明細",
    "withAdvance": "立替込み",
    "tapReview": "タップして清掃詳細",
    "myPay": "自分の明細"
  },
  "taskStatus": {
    "PENDING": "未割当",
    "ASSIGNED": "予定",
    "SUBMITTED": "確認待ち",
    "APPROVED": "確認済み",
    "REJECTED": "差し戻し",
    "CANCELLED": "取消"
  },
  "error": {
    "NETWORK_ERROR": "ネットワークに接続できません。通信状況をご確認ください",
    "TIMEOUT": "通信がタイムアウトしました。再試行してください",
    "AUTH_BAD_CREDENTIALS": "ユーザー名またはパスワードが正しくありません",
    "AUTH_CURRENT_PASSWORD_WRONG": "現在のパスワードが正しくありません",
    "AUTH_TOKEN_MISSING": "ログインしてください",
    "AUTH_TOKEN_INVALID": "ログイン情報が無効です。再度ログインしてください",
    "AUTH_TOKEN_EXPIRED": "ログインの有効期限が切れました。再度ログインしてください",
    "AUTH_ACCOUNT_DISABLED": "このアカウントは停止されています。管理者にご連絡ください",
    "AUTH_FORBIDDEN": "この操作を行う権限がありません",
    "AUTH_PASSWORD_CHANGE_REQUIRED": "先にパスワードを変更してください",
    "TENANT_MISMATCH": "このデータにアクセスする権限がありません",
    "TENANT_CONTEXT_MISSING": "システムエラーです。管理者にご連絡ください",
    "TENANT_SUSPENDED": "所属する組織が停止されています。管理者にご連絡ください",
    "VALIDATION_FAILED": "入力内容に誤りがあります。ご確認ください",
    "RESOURCE_NOT_FOUND": "データが存在しないか、削除されています",
    "USERNAME_ALREADY_EXISTS": "この組織内でユーザー名が使われています。別の名前にしてください",
    "CLIENT_NAME_ALREADY_EXISTS": "同じ名称の家主が既にあります",
    "BUILDING_NAME_ALREADY_EXISTS": "この家主には同じ名称の棟が既にあります",
    "ROOM_NAME_ALREADY_EXISTS": "この棟には同じ部屋番号が既にあります",
    "RESOURCE_HAS_DEPENDENTS": "下位のデータが残っているため削除できません。アーカイブをご利用ください",
    "PARENT_ARCHIVED": "上位がアーカイブされています。先に戻してください",
    "TASK_NOT_EDITABLE": "スタッフが報告済みのため、部屋と金額は変更できません。差し戻してから変更してください",
    "TASK_DATE_IN_PAST": "本日より前の日付にも登録できます",
    "SMS_NOT_ENTITLED": "SMS送信は未開通です。課金後に管理者の開通が必要です",
    "SMS_NOT_CONFIGURED": "SMS送信元が未設定です。管理者に連絡してください",
    "SMS_SEND_FAILED": "SMS送信に失敗しました",
    "TASK_INVALID_TRANSITION": "この作業の状態が変わっています。画面を更新してください",
    "TASK_ROOM_ARCHIVED": "この部屋は停止中のため、新しい清掃を登録できません",
    "TASK_DUPLICATE_ASSIGNEE": "同じ人が二重に追加されています",
    "TASK_ASSIGNEE_INVALID": "このスタッフは存在しないか停止中です。選び直してください",
    "TASK_ASSIGNEE_LIMIT_EXCEEDED": "1件に割り当てられるのは最大5人までです",
    "TASK_PAY_INPUT_INVALID": "割合または金額の入力が正しくありません",
    "TASK_REJECT_REASON_REQUIRED": "差し戻し理由を入力してください。スタッフはこれを見て修正します",
    "TASK_WORK_LABEL_REQUIRED": "その他の作業は内容を書いてください。給与・請求書の照合に必要です",
    "INTERNAL_ERROR": "サーバーエラーが発生しました。しばらくしてからお試しください"
  },
  "entryCheck": {
    "title": "登録確認",
    "open": "部屋の登録漏れを確認",
    "empty": "確認できる部屋はありません",
    "registered": "登録済み",
    "unregistered": "未登録"
  },
  "submitForm": {
    "title": "完了報告",
    "note": "完了メモ",
    "completionPhotos": "完了写真",
    "existingPhotos": "既存の写真 {count} 枚",
    "amount": "金額",
    "description": "説明",
    "paidBy": "立替者",
    "noPayer": "指定なし",
    "receipt": "レシート写真",
    "submit": "完了を報告",
    "success": "完了報告を送信しました",
    "types": {
      "DRYER": "乾燥機代",
      "SUPPLIES": "消耗品費",
      "SPECIAL": "特別費用"
    },
    "expenses": "経費明細",
    "paidBySelf": "自分が立替",
    "addPhoto": "写真",
    "amountPlaceholder": "0",
    "descriptionPlaceholder": "内容（任意）",
    "specialDescPlaceholder": "理由（任意）",
    "notePlaceholder": "メモ（任意）",
    "addNote": "メモを追加",
    "dryerHint": "金額だけ入力。右のボタンで領収書",
    "clear": "クリア"
  },
  "reviewHistory": {
    "title": "確認履歴",
    "open": "履歴",
    "allStatuses": "すべて",
    "approved": "承認済み",
    "rejected": "差し戻し",
    "empty": "今月の確認履歴はありません"
  },
  "statement": {
    "title": "家主請求明細",
    "cleaning": "清掃料",
    "dryer": "乾燥機代",
    "supplies": "消耗品費",
    "special": "特別費用",
    "empty": "今月の明細はありません",
    "tapReview": "タップして確認詳細",
    "makeInvoice": "請求書を作る"
  },
  "invoice": {
    "title": "請求書",
    "open": "請求書",
    "profileLink": "請求書の宛名",
    "profileTitle": "請求書の宛名",
    "profileHint": "請求書の右上に入る会社情報と振込先です。一度入れれば使い回せます。",
    "needProfile": "会社名と振込先が未入力です。請求書のその部分は空になります。",
    "fillProfile": "入力する",
    "client": "家主",
    "pickClient": "家主を選択",
    "includeHint": "チェックしたものだけ請求書に載ります。乾燥機代は列、消耗品とその他は当日の部屋の下に1行です。全部外すと清掃料だけになります。",
    "dryer": "乾燥機代",
    "supplies": "消耗品費",
    "special": "その他費用",
    "invoiceDate": "請求日",
    "number": "請求番号",
    "dueDate": "振込期限",
    "download": "Wordでダウンロード",
    "print": "印刷",
    "downloaded": "請求書をダウンロードしました",
    "empty": "今月の承認済み清掃がないため明細がありません",
    "emptyHint": "承認された清掃だけが請求書に出ます",
    "legalName": "会社名",
    "registrationNumber": "登録番号",
    "representative": "代表取締役",
    "postalCode": "郵便番号",
    "address": "住所",
    "tel": "電話",
    "email": "メール",
    "bankName": "銀行",
    "bankBranch": "支店",
    "accountType": "口座種別",
    "accountTypePh": "普通",
    "accountNumber": "口座番号",
    "accountHolder": "口座名義",
    "saved": "保存しました"
  },
  "payroll": {
    "title": "スタッフ給与明細",
    "cleaning": "清掃給",
    "reimbursement": "立替経費",
    "special": "特別手当",
    "empty": "今月の給与明細はありません",
    "tapReview": "タップして確認詳細",
    "markPaid": "支給済みにする",
    "markPending": "未支給に戻す",
    "markedPaid": "支給済みにしました",
    "markedPending": "未支給に戻しました",
    "paidAt": "支給済 · {date}",
    "confirmNext": "続ける",
    "confirmPaidTitle1": "支給済みにしますか？",
    "confirmPaidMessage1": "{name} の {month} 支給合計 {amount} を支給済みにします。すでに支払済みか確認してください。",
    "confirmPaidTitle2": "再確認：支給済み",
    "confirmPaidMessage2": "{name} の今月分 {amount} を支給済みにしてよいですか？経営画面に「支給済み」と表示されます。",
    "confirmPaidFinal": "支給済みにする",
    "confirmPendingTitle1": "未支給に戻しますか？",
    "confirmPendingMessage1": "{name} の {month} 「支給済み」を取り消します。",
    "confirmPendingTitle2": "再確認：未支給に戻す",
    "confirmPendingMessage2": "{name} を「未支給」に戻してよいですか？誤って支給済みにした場合のみ使います。",
    "confirmPendingFinal": "未支給に戻す"
  },
  "sms": {
    "title": "SMS通知",
    "settingsLink": "SMS通知設定",
    "phone": "受信番号",
    "phoneHint": "国際形式（例 +819012345678）。Twilioトライアルは認証済み番号のみ。",
    "morning": "1回目（午前）",
    "morningHint": "本日の清掃予定に向いています",
    "afternoon": "2回目（午後）",
    "afternoonHint": "明日の予定、または本日の成果に向いています",
    "contentPick": "このSMSの内容",
    "kindToday": "本日の清掃予定",
    "kindTodayHint": "民宿・部屋・担当・当日IN",
    "kindTomorrow": "明日の清掃予定",
    "kindTomorrowHint": "明日の民宿・部屋・担当・当日IN",
    "kindResults": "本日の清掃成果",
    "kindResultsHint": "完了数・収入・支出・未確認の有無",
    "maxRooms": "予定SMSに載せる部屋数の上限",
    "maxRoomsHint": "超えた分は「他N件」と書き、文字数と料金を抑えます",
    "locale": "SMS言語",
    "sendTest": "テストSMSを送る",
    "testMorning": "午前内容をテスト",
    "testAfternoon": "午後内容をテスト",
    "testSent": "テストSMSを送信しました",
    "entitlementOff": "SMS送信は未開通です。設定は保存できます。課金後に管理者の開通が必要です。",
    "providerOff": "サーバー側の送信元が未設定です。管理者に連絡してください。",
    "entitlementOn": "SMS送信は開通済みです",
    "trialHint": "Twilioトライアルでテンプレ制限（572006）が出る場合：アカウントをアップグレードするか TWILIO_CONTENT_SID を設定してください。送信先は検証済み番号である必要があります。"
  },
  "adminOrgs": {
    "nav": "テナント管理",
    "title": "テナントと課金",
    "subtitle": "主体の開通、微信月額の記録、SMS権限。決済APIは予約済み。",
    "createTitle": "代理で組織を開通",
    "orgName": "組織名",
    "loginCode": "ログインコード",
    "ownerUsername": "オーナーID",
    "ownerPassword": "初期パスワード",
    "ownerDisplayName": "オーナー名",
    "create": "作成",
    "created": "作成しました",
    "updated": "更新しました",
    "active": "ログイン可",
    "inactive": "停止中",
    "suspend": "ログイン停止",
    "activate": "ログイン再開",
    "smsOn": "SMS開通済み",
    "smsOff": "SMS未開通",
    "smsEnable": "SMSを開通",
    "smsDisable": "SMSを停止",
    "smsUpdated": "SMS権限を更新しました",
    "extendBox": "微信入金後：月額開通（下のボタンで適用）",
    "extendHint": "月数/金額/メモを入れてから、対象テナントの「月額開通」を押します。",
    "months": "月数",
    "amountYen": "金額(円)",
    "note": "メモ",
    "notePh": "微信振込番号",
    "extendAction": "月額開通",
    "extended": "月額期間を開通しました",
    "showLedger": "課金履歴",
    "hideLedger": "履歴を閉じる",
    "ledgerEmpty": "履歴なし",
    "billingNote": "メモ",
    "voidAction": "取消す",
    "voided": "月額開通を取り消しました",
    "voidedBadge": "取消済",
    "voidNext": "続ける",
    "voidTitle1": "この月額開通を取り消しますか？",
    "voidMessage1": "{org} の {period}（{amount}）を取り消します。期限日も再計算されます。",
    "voidTitle2": "再確認：月額開通の取消",
    "voidMessage2": "{org} のこの課金記録を取り消してよいですか？取り消すと履歴に取消行が残ります。",
    "voidFinal": "取り消す",
    "resetPassword": "パスワード再設定",
    "resetPasswordTitle": "オーナーのパスワードを再設定",
    "resetPasswordMessage": "{name}（{username}）のログインパスワードを、入力した内容に変更します。",
    "resetPasswordPlaceholder": "新しいパスワード（8文字以上）",
    "resetPasswordConfirm": "再設定する",
    "resetPasswordSuccess": "{name} のパスワードを再設定しました",
    "resetPasswordNeedOwner": "この組織にはオーナーアカウントがありません",
    "kind": {
      "MONTHLY_FEE": "月額開通",
      "MONTHLY_FEE_VOID": "月額取消",
      "SMS_ENABLE": "SMS開通",
      "SMS_DISABLE": "SMS停止",
      "ADJUSTMENT": "調整",
      "NOTE": "メモ"
    },
    "sub": {
      "NONE": "未課金",
      "TRIAL": "トライアル",
      "ACTIVE": "課金中",
      "EXPIRED": "期限切れ"
    }
  },
  "ownerMonth": {
    "title": "月間一覧",
    "open": "今月の一覧",
    "total": "全タスク",
    "pending": "未割当",
    "assigned": "割当済み",
    "submitted": "確認待ち",
    "approved": "確認済み",
    "empty": "この月の清掃タスクはありません",
    "emptyHint": "登録すると日付ごとに表示されます",
    "openDay": "その日を見る",
    "byDate": "日付別",
    "byBuilding": "棟別",
    "byBuildingHint": "棟ごとに今月の清掃をまとめます",
    "byStaff": "スタッフ別",
    "byStaffHint": "合掃は各スタッフの下に重複表示されます",
    "unassigned": "未割当",
    "unknownBuilding": "不明な棟",
    "staffTaskCount": "{count} 件",
    "staffSameDay": "当日チェックイン {count}",
    "staffPay": "今月明細 {amount}",
    "exportExcel": "Excel",
    "exportStaffPayExcel": "スタッフ給与",
    "excelExported": "Excelを出力しました",
    "staffPayExcelExported": "スタッフ給与Excelを出力しました",
    "staffPayExcelFilename": "スタッフ給与_{year}年{month}月.xlsx",
    "staffPayExcelTitle": "{name} · {year}年{month}月給与",
    "staffPayExcelGrand": "今月支払合計 {amount}",
    "staffPayExcelBuilding": "{name}",
    "staffPayExcelSubtotal": "物件小計",
    "staffPayExcelTotal": "スタッフ合計",
    "staffPayExcelEmpty": "今月は確定済みの給与明細がありません（先に確認してください）",
    "staffPayExcelEmptySheet": "データなし",
    "excelSheet": "{year}年{month}月清掃",
    "excelFilename": "清掃一覧_{year}年{month}月.xlsx",
    "excelBuildingTitle": "{name}",
    "excelYes": "はい",
    "excelNo": "いいえ",
    "excelNoBuildings": "棟がまだありません",
    "excelShared": "複数人清掃",
    "excelWorkKindCleaning": "清掃",
    "excelWorkKindOther": "その他",
    "staffPayExcelCol": {
      "date": "日付",
      "room": "部屋番号",
      "workKind": "種別",
      "workLabel": "その他の内容",
      "cleaningPay": "清掃給与",
      "dryer": "乾燥機代",
      "supplies": "消耗品費",
      "special": "特別費用",
      "specialReason": "特別費用の事由",
      "rowTotal": "小計",
      "note": "備考"
    },
    "excelCol": {
      "date": "日付",
      "weekday": "曜日",
      "staff": "清掃担当",
      "room": "部屋番号",
      "sameDay": "当日チェックイン",
      "guests": "宿泊人数",
      "nights": "宿泊日数",
      "workKind": "種別",
      "workLabel": "その他の内容",
      "clientPay": "依頼主請求",
      "staffPay": "スタッフ支給",
      "dryer": "乾燥機代",
      "supplies": "消耗品費",
      "special": "特別費用",
      "specialReason": "特別費用の事由",
      "note": "備考"
    }
  },
  "quickEntry": {
    "title": "かんたん登録",
    "open": "かんたん登録",
    "empty": "登録できる建物・部屋はありません",
    "registered": "登録済み",
    "sameDay": "当日チェックイン",
    "submit": "{count} 室を登録",
    "success": "{created} 室を登録、{skipped} 室をスキップしました",
    "keepHint": "日付・棟を切り替えても選択は残ります",
    "selectAll": "この棟を全選択",
    "clearBuilding": "この棟をクリア",
    "tapToPick": "タップで選択",
    "picked": "選択中",
    "submitAll": "選択した {count} 室をすべて保存",
    "otherDatesPending": "他の日に未保存 {count} 室あり",
    "unregister": "取消",
    "registeredTapCancel": "登録済み · 取消可",
    "registeredLocked": "提出/確認済みのためここでは取消不可",
    "cannotUnregister": "提出または確認済みです。カレンダーから操作してください",
    "unregisterTitle": "登録を取消しますか？",
    "unregisterMessage": "{room} のこの日の清掃登録を削除します（未提出の場合）。",
    "unregisterConfirm": "取消する",
    "unregisterPastTitle1": "過去日の予定を削除しますか？",
    "unregisterPastMessage1": "{date} · {room} の過去予定です。削除すると元に戻せません。続行しますか？",
    "unregisterPastTitle2": "再確認：過去予定を削除",
    "unregisterPastMessage2": "{date} · {room} の清掃登録を完全に削除します。もう一度確認してください。",
    "unregisterPastNext": "削除を続ける",
    "unregistered": "{room} を取消しました",
    "pastHint": "過去日の予定を削除する場合は2回確認が必要です",
    "pastNoSchedule": "本日より前の日付にも新規登録できます",
    "pastRoomHint": "新規登録可"
  },
  "staffMonth": {
    "title": "今月の予定",
    "open": "月一覧",
    "total": "今月合計",
    "count": "{count} 件",
    "todo": "未完了",
    "pending": "確認待ち",
    "done": "確認済み",
    "paySum": "明細合計",
    "empty": "今月の担当はありません",
    "emptyHint": "割り当て後に表示されます",
    "openDay": "その日を見る"
  }
}
